import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic,Progress  } from 'antd';
import {balanceOf,signer, transfer} from '../../utils/ethers'
import StripedProgressBar from '../../components/progress/Progress'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined,DownOutlined,ExportOutlined,CheckCircleOutlined,StopOutlined,ClockCircleOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { getLpInfo,addPledgeLp} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Pool = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)

    const [total,setTotal] = useState(0)
    const [bnb,setBnb] = useState(0)
    const [token,setToken] = useState(0)
    const [receive,setReceive] = useState(0)
    const [needValue,setNeedValue] = useState("")
    const [needBnb,setNeedBnb] = useState("")
    const [needToken,setNeedToken] = useState("")

    const [min,setMin] = useState(1)

    const [token_n,setTokenN] = useState(0)

    const [worth,setWorth] = useState(0)
    
  
  

    const [pledgeRecords1,setPledgeRecords1] = useState([])


    const [allBonusPledgeCcer,setAllBonusPledgeCcer] = useState(0)
    const [allPledgeCcer,setAllPledgeCcer] = useState(0)

  const [tab, setTab] = useState(0);
    
     const [balanceLp,setBalanceLp]=useState(0)
    

  const [isShowMenu,setIsShowMenu] = useState(false);

    
    const [isLock,setIsLock]=useState(false)



    const [tabIndex ,setTabIndex] = useState(2)

const tabs = [
  t('pl.添加算力'),
  t('pl.团队数据')
];








    
    const _rand= () =>{
    //     message.error(t('g.暂未开始'))
    //    return
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('g.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('g.您还未绑定钱包，请绑定激活钱包地址'))
            return false
        }
   

      
        if(!needValue){
            message.error(t('pl.请输入LP数量'))
            return false
        }
        if(needValue.length<=0){
            message.error(t('pl.请输入LP数量'))
            return false
        }
        if(parseFloat(needValue)<parseFloat(min)){
            message.error(t('pl.不能小于最小量')+":"+min)
            return false
        }

         if(parseFloat(needValue)>parseFloat(balanceLp)){

                message.error("LP"+t('pl.可用数量不足'))
                return false
            }
       
    
            
        if(receive.length==0){
                      message.error(t('mint.钱包地址获取错误'))
                    return false
                }




        if(isLock) return false;
        setIsLock(true)

        transfer(props.address,receive,"lp",needValue).then(
            res=>{
                addPledgeLp({
                    address:props.address,
                    value:needValue.toString(),
                    hex:res.hash,
                }).then(
                    res=>{
                        message.success(res.msg)
                        
                        setNum(num+1);
                        setIsLock(false)
                    })
            }, error=>{
                setIsLock(false)
                message.error(error)
            })



      



    }



    const _getPledgeCcerIndex= () =>{
        // if(props.address.length === 0 || props.isLogin === false){
        //     return false
        // }
        getLpInfo().then(res=>{
            if(res.code === 0 ){

                
               setTotal(res.data.total)
                setBnb(res.data.bnb)
                setToken(res.data.token)

                setAllPledgeCcer(res.data.user_lp)
                setAllBonusPledgeCcer(res.data.bonus)

                setTokenN(res.data.spacex_n)
                setReceive(res.data.receive)

                if(res.data.list != null){
                    setPledgeRecords1(res.data.list)
                }

        
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

    


 const _balanceOf = () =>{
        if(props.address.length<=0 || !props.isLogin) return false
        balanceOf(props.address,'lp').then(res1=>{
            console.log(res1)
            setBalanceLp(res1)
            getLpInfo().then(res=>{
                    if(res.code === 0 ){

                        
                    setTotal(res.data.total)
                        setBnb(res.data.bnb)
                        setToken(res.data.token)

                        setAllPledgeCcer(res.data.user_lp)
                        setAllBonusPledgeCcer(res.data.bonus)

                        setTokenN(res.data.spacex_n)
                        setReceive(res.data.receive)

                        if(res.data.list != null){
                            setPledgeRecords1(res.data.list)
                        }

                       
                
                            

                    }else{
                        message.error(res.msg)
                    }
                },error =>{
                    message.error(error)
                })

        })

    }


 const _getPoolToken = (e) =>{
    console.log(e)
    setNeedValue(e)
    setNeedBnb(e*bnb/total)
    setNeedToken(e*token/total)
 }
   



    useEffect(() => {
            window.scrollTo(0, 0)
            _balanceOf()

    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
       
        <Head/>
                    <div className=' plbg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                        {/*  */}
                        <div className='w-full lg:w-1/3 px-0   min-h-[93px]  flex flex-row  '>
                            {/* <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[203px]  absolute '>
                                
                            </div> */}
                            <div className='w-[57%] pl-4 flex flex-col z-40'>
                                {/* <img className='mt-5  '  src={require('../../assets/task/title.png')} style={{"width":"406px"}}></img>
                                <span className='mt-[2px] text-text1 text-[9px]' >{t('tr.完成交易考核，解锁释放额度')}</span> */}
                              
                               
                                
        
                            </div>
                            
                        </div>

                        {/*  */}
                        {/* <div className="stake-tab-wrap mx-4 mb-2">
                            {tabs.map((item, index) => (
                                <div
                                key={index}
                                onClick={() => setTab(index)}
                                className={`stake-tab-item ${
                                    tab === index ? "active" : ""
                                }`}
                                >
                                {item}
                                </div>
                            ))}

                            <div
                                className="stake-tab-indicator"
                                style={{
                                transform: `translateX(${tab * 100}%)`
                                }}
                            />
                            </div> */}
                        {/*  */}


                        {
                            tab==0?(
                                <>
                                    <div className='mx-4  mt-3 airDataBg2  h-[60px]  flex flex-row justify-between items-center'>
                            
                            
                                        <div className=' flex flex-row justify-center items-center w-[168px] px-2 py-2 '>
                                            {/* <img className='mr-2 '  src={require('../../assets/task/icon1.png')} style={{"width":"30px"}}></img> */}
                                            <div className='flex flex-col justify-center items-start'>
                                                <span className='text-gray-400 text-[9px]'>{t('pl.当前质押')} LP</span>
                                                <span className=' text-base'><CountUp start={0} end={allPledgeCcer} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                        <div className="w-px h-10 mr-2 bg-gradient-to-b from-transparent via-[#071C27] to-transparent" ></div>
                                        <div className=' flex flex-row justify-center items-center w-[168px] px-2 py-2 '>
                                            {/* <img className='mr-2 '  src={require('../../assets/task/icon1.png')} style={{"width":"30px"}}></img> */}
                                            <div className='flex flex-col justify-center items-start'>
                                                <span className='text-gray-400 text-[9px]'>{t('pl.累积收益')} SPACEX</span>
                                                <span className=' text-base'><CountUp start={0} end={allBonusPledgeCcer} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mx-4  mt-3 pl-3 pr-3 pt-4 plbg1 min-h-[350px]  flex flex-col justify-start'>
                                        <div className='w-full flex flex-row justify-center'>
                                            <span className='mt-1 text-text1 text-[11px] leading-[11px]'>{t('pl.质押')} LP-CAKE</span>
                                        </div>
                                            
                                        
                                        <div className='mt-2 w-full flex flex-col items-center relative'>
                                            {/* <img className='-bottom-5  absolute z-[40]'  src={require('../../assets/ipo/arr.png')} style={{"width":"30px"}}></img> */}
                                            <div className="w-full min-h-[30px]
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                
                                                    <span className='text-[10px] leading-[10px] text-gray-400'>LP {t('tr.当前余额')}: <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={balanceLp}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                    
                                                </div>
                                            
                                            
                                            
                                            </div>
                                        </div>

                                        <div className='mt-2 w-full flex flex-col items-center relative'>
                                            <div className="w-full min-h-[50px]
                                                    relative inline-flex flex-row h-4  justify-between items-center
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <span className='text-[10px] leading-[10px] text-text1 z-10'>{t('pl.输入质押数量')}</span>
                                                <div className=' w-1/2    flex flex-row justify-center items-center  z-10'>
                                                                <input  type="number" onInput={(e)=>_getPoolToken(e.target.value)} value={needValue} placeholder={t('mint.输入最低')+" 100 LP"}  className='placeholder:text-[10px] w-full text-base text-white input1 text-right '  />
                                                        </div>
                                            </div>
                                        </div>
                    
                                        {/* <div className='mt-2 w-full flex flex-col items-center relative'>
                                            <div className="w-full min-h-[50px]
                                                    relative inline-flex flex-col h-4  justify-start 
                                                    px-3 py-2 text-white text-[10px]  tracking-wider
                                                    [--cut:4px] [--border:1px]
                                                    before:absolute before:inset-0 before:bg-gray-800
                                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                ">
                                                <div className='w-full z-10 flex flex-row justify-between items-center'>
                                                    <span className='text-[10px] leading-[10px] text-text1'>{t('pl.需质押')}</span>
                                                    
                                                </div>
                                            <div className='mt-1 w-full z-10 flex flex-row justify-between items-center'>
                                                    <div className="w-[100px]
                                                        relative inline-flex h-5 items-center justify-start
                                                        px-2 py-3 text-white text-[10px]  tracking-wider
                                                        [--cut:3px] [--border:1px]
                                                        before:absolute before:inset-0 before:bg-gray-800
                                                        before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                        after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                                        after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    ">
                                                        <img className='  z-10' alt='logo' src={require('../../assets/ipo/bnb.png')} style={{"width":"17px"}}></img>
                                                        <span className="ml-1 z-10 text-[12px] text-[#F9B514]">LP</span>
                                                        <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  /></span>
                                                    </div>
                                                    <div className=' w-1/2    flex flex-row justify-center items-center  '>
                                                                <input  type="number" disabled value={needToken}   className='placeholder:text-[10px] w-full text-base text-white input1 text-right '  />
                                                        </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        
                                        
                                        {/* <div className='mt-3 mb-3 w-full flex flex-row justify-center'>
                                            <span className=' text-text1 text-[11px] leading-[11px]'>{t('pl.选择质押周期')}</span>
                                        </div> */}
                                           
                    
                    
                                            <div className="w-full mt-3
                                                        relative inline-flex flex-col items-start justify-start
                                                        px-2 py-2 text-white text-[10px]  tracking-wider
                                                        [--cut:6px] [--border:1px]
                                                        before:absolute before:inset-0 before:bg-gray-800
                                                        before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                        after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                                        after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                    ">
                                                <div className=' w-full flex flex-row justify-between items-center z-10'>
                                                    <div className=' flex flex-row justify-between items-center'>
                                                        <img className='mr-1 '  src={require('../../assets/task/icon1.png')} style={{"width":"10px"}}></img>
                                                        <span className='text-gray-400 text-[9px]'>BNB{t('pl.数量')}</span>
                                                    </div>
                                                    <span className='text-gray-200 text-xs'>
                                                       <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={needBnb}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} />
                                                    </span>
                                                </div>
                                                <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                                                <div className=' w-full flex flex-row justify-between items-center z-10'>
                                                    <div className=' flex flex-row justify-between items-center'>
                                                        <img className='mr-1 '  src={require('../../assets/task/icon2.png')} style={{"width":"10px"}}></img>
                                                        <span className='text-gray-400 text-[9px]'>SPACEX{t('pl.数量')}</span>
                                                    </div>
                                                    <span className='text-gray-200 text-xs'>
                                                        <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={needToken}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    allowNegative={false}
                                                    decimalScale={2} />
                                                    </span>
                                                </div>
                                                <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                                            
                                                
                                        </div>
                                        <div className="flex justify-center w-full mt-3 mb-8">
                                            <button onClick={_rand} className="sci-glow-btn"> <span>{t('pl.质押')}</span></button>
                                        </div>
                    
                                    </div>
                                     {/*  */}
                                    <div className='w-full my-2 flex flex-row justify-center items-center'>
                                        <span className='text-text1 text-xs'>{t('pl.质押记录')}</span>
                                    
                                    </div>
                        
                                    {/*  */}
                                    {
                                    pledgeRecords1.length>0?
                                    pledgeRecords1.map((item,index)=>{
                                        return(
                                            <>
                                                <div className="mx-4  mt-4 py-5 px-5 pt-7 flex flex-col justify-start items-center SWAPbg1">    
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.质押')} LP</span>
                                                        <span className=' text-[10px] text-white'> <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix="" 
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} />
                                                            &nbsp; LP
                                                            
                                                            </span>
                                                    </div>
                                                
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.池子占比')}</span>
                                                        <span className=' text-[10px] text-white'> <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} /> / <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={total}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2} />

                                                            </span>
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.当前价值')}</span>
                                                        <span className=' text-[10px] text-text1'><NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value* bnb / total}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={4} />
                                                            &nbsp; BNB + <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value * token / total}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={4} />&nbsp; SPACEX </span>
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.已获收益')}</span>
                                                        <span className=' text-[10px] text-text1'><NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.all_bonus}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={4} />
                                                            &nbsp; SPACEX</span>
                                                    </div>
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.质押时间')}</span>
                                                        <span className=' text-[10px] text-white'><Moment format="YY-MM-DD HH:mm" unit="days" unix>{item.btime}</Moment></span>
                                                    </div>
                                                    {/* <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.解锁时间')}</span>
                                                        {
                                                            item.days >0?(
                                                                <span className=' text-[10px]  text-red-500'><Moment format="YY-MM-DD HH:mm" unit="days" unix>{item.etime}</Moment></span>
                                                            ):(
                                                                <span className=' text-[10px]  text-green-500'>{t('pl.自由')}</span>
                                                            )
                                                        }
                                                        
                                                    </div> */}
                                                    <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                
                                                    <div className='w-full flex flex-row justify-between items-center'>
                                                        <span className=' text-[9px] text-gray-400'>{t('pl.我的状态')}</span>
                                                        {
                                                            item.state == 0?(
                                                                <span className=' text-[10px] text-green-500'>{t('pl.工作中')}</span>
                                                            ):(
                                                                <span className=' text-[10px] text-red-500'>{t('pl.确认中')}</span>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                    {/* <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                                    {
                                                            item.state == 0?(
                                                                <div className="flex justify-center w-full mt-1 mb-1">
                                                                    <button onClick={()=>hui(item.order_num,item.state,item.etime,item.path)} className="sci-glow-btn"> <span>{t('pl.赎回')}</span></button>
                                                                </div>
                                                            ):null
                                                        } */}
                                                    
                                                </div>
                                            
                                            </>
                                        )
                                    }):(
                                        
                                        <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                                No data
                                        </div>
                                    )
                                }
                                     
                                {/*  */}
                                </>
                            ):(
                                <>
                                
                                </>
                            )
                        }

                        
                        
        
                        
                       
                       
                                       
        
                        {/*  */}
                        
                        {/*  */}
                        <div className=' h-[100px]'></div>
                    </div>
                   
                    
                       
                   <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(Pool);
